/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const paymentOverviewDataSchema = z.object({
	paymentTerms: z.number(),
	credits: z.number(),
	card: z.object({ id: z.string(), brand: z.string(), last4: z.string(), expMonth: z.number(), expYear: z.number() })
		.nullable(),
})

export type PaymentOverviewDataSchema = z.infer<typeof paymentOverviewDataSchema>
